/* eslint-disable import/no-anonymous-default-export */
import { SET_TAB_DETAIL, SET_FILTER_DETAIL } from './types'
import { tabList } from '../../components/dataVisualization/visualization.description'
const firstTab = tabList.at(0)

const initialState = {
  tabDetails: {
    currentTab: firstTab.key,
    currentSubTab: firstTab.subTabList.at(0).key,
  },
  filterDetails: {
    tag: '',
    value: '',
  },
}

export default (state = initialState, action) => {
  const { type, payload } = action
  switch (type) {
    case SET_TAB_DETAIL:
      return {
        ...state,
        tabDetails: { ...state.tabDetails, ...payload },
      }
    case SET_FILTER_DETAIL:
      return {
        ...state,
        filterDetails: { ...state.filterDetails, ...payload },
      }

    default:
      return state
  }
}
